<template lang="html">
  <header class="bg-primary shadow pt-16 pb-16">
    <div class="wrapper text-center">
      <h1 class="text-3xl font-semibold text-white mx-auto">
        {{ heading }}
      </h1>
      <h2 class="text-white mx-auto" v-if="subheading">{{subheading}}</h2>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: ['heading','subheading']
}
</script>

<style lang="css">
</style>
